<template>
  <div style="height: 100%" class="pa-4">
    <v-row justify="space-between">
      <v-col v-if="!noHeader">
        <div class="font-weight-bold basic--text text-center">{{ 'Personal Details'.toUpperCase() }}</div>
      </v-col>
    </v-row>
    <v-form ref="form" v-model="dataValid">
      <v-row justify="space-between">
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Surname" required :rules="textRules" :disabled="!canEdit" v-model="obj.lastName" :value="user.lastName"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Middle name" :disabled="!canEdit" v-model="obj.middleName"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="First name" required :rules="textRules" :disabled="!canEdit" v-model="obj.firstName"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="space-between" class="mt-0">
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Place of birth" required :rules="textRules" :disabled="!canEdit && getInformation != null && getInformation.placeOfBirth != null" v-model="obj.placeOfBirth"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    label="Date of birth"
                    readonly
                    outlined
                    dense
                    required :rules="textRules"
                    v-model="obj.dob"
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="obj.dob"
                  no-title
                  :active-picker.sync="activePicker"
                  locale="en-NG"
                  min="1900-01-01"
                  :max="today"
                  @change="saveDob"
              >
              </v-date-picker>
            </v-menu>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div>
            <v-select :items="genders" item-value="id" item-text="title" dense outlined label="Sex" required :rules="textRules" :disabled="!canEdit" v-model="obj.genderId"></v-select>
          </div>
        </v-col>
      </v-row>

      <v-row justify="space-between" class="mt-0">
        <v-col cols="12" md="4">
          <div>
            <v-select :items="maritalStatus" item-value="id" item-text="title" dense outlined label="Marital Status" required :rules="textRules" :disabled="!canEdit && getInformation != null && getInformation.maritalStatus != null" v-model="obj.maritalStatusId"></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Phone" required :rules="textRules" :disabled="!canEdit && getUser != null && getUser.phone != null" v-model="obj.phone"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :items="countries" item-value="id" item-text="name" outlined dense label="Country" required :rules="textRules" :disabled="!canEdit" v-model="selectedCountry"></v-select>
        </v-col>
      </v-row>

      <v-row justify="space-between">
        <v-col cols="12" md="4">
          <v-select :items="states" item-value="id" item-text="name" outlined dense label="State" required :rules="textRules" :disabled="!canEdit" v-model="selectedState"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select :items="lgas" item-value="id" item-text="name" outlined dense label="LGA" required :rules="textRules" :disabled="!canEdit && getInformation != null && getInformation.lga != null" v-model="selectedLga"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="Hometown" required :rules="textRules" :disabled="!canEdit && getInformation != null && getInformation.homeTown != null" v-model="obj.homeTown"></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="start" v-if="getUser && getUser.admission.applicationType.utmeRegEnabled">
        <v-col cols="12" md="4">
          <v-text-field outlined dense label="UTME no." required :rules="textRules" :disabled="!canEdit && getUser.jambRegistrationNumber != null" v-model="obj.utmeReg"></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <v-card-actions class="mt-6">
      <v-spacer></v-spacer>
      <v-btn color="error" depressed @click="$refs.form.reset()" :disabled="!dataValid" v-if="canEdit && !noHeader">Reset</v-btn>
<!--      <v-btn color="primary" depressed @click="update" :disabled="!dataValid" v-if="canEdit || (getInformation != null && getInformation.lga == null)">Proceed</v-btn>-->
      <v-btn color="primary" depressed @click="update" :disabled="!dataValid">{{ noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn color="info" depressed @click="success" v-if="getInformation != null && getInformation.lga != null">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import ValidationRules from "@/shared/ValidationRules";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {mapGetters} from "vuex";
import StudentStatus from "@/shared/StudentStatus";
import DateUtil from "@/shared/DateUtil";

export default {
  name: "PersonalDetails",
  props: {
    noHeader: Boolean
  },
  components: {MessageBox, LoadingDialog},
  data() {
    return {
      obj: {},
      date: null,
      activePicker: null,
      menu: false,
      today: DateUtil.toDateOnly(new Date()),
      genders: [],
      maritalStatus: [],
      countries: [],
      states: [],
      lgas: [],
      selectedLga: null,
      selectedState: null,
      selectedCountry: null,
      dataValid: true,
      textRules: ValidationRules.textRules,
      messageType: '',
      message: '',
      messageShow: false,
      loading: false,
      user: {}
    }
  },

  methods: {
    success() {
      this.$emit('success')
    },

    saveDob(date) {
      this.$refs.menu.save(date)
    },

    update(){
      // if already updated
      // if(this.getUser != null && this.getUser.firstName != null){
      //   this.success()
      //   return
      // }
      this.obj.countryId = this.selectedCountry
      this.obj.stateId = this.selectedState
      this.obj.lgaId = this.selectedLga
      this.loading = true
      Api.applicants.personalDetailsUpdate(this.getUser.id, this.obj)
          .then(res => {
            this.message = 'Personal details updated'
            this.messageType = 'success'
            this.messageShow = true
            this.$store.commit('setCurrentUser', res.data)
            this.$store.commit('setInformation', res.data.information)
            this.success()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadCountries(){
      this.loading = true
      Api.nationality.getCountries()
          .then(res => this.countries = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadStates(){
      this.loading = true
      this.states = []
      this.lgas = []
      Api.nationality.getStates(this.selectedCountry)
          .then(res => {
            this.states = res.data
            // update state object
            if(this.getInformation != null && this.getInformation.state != null)
              this.selectedState = this.getInformation.state.id
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadLgas(){
      this.loading = true
      this.lgas = []
      Api.nationality.getLgas(this.selectedState)
          .then(res => {
            this.lgas = res.data
            if(this.getInformation != null && this.getInformation.lga != null)
              this.selectedLga = this.getInformation.lga.id
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadBasicInfo(){
      this.loading = true
      Api.basicInformation.getAll()
          .then(res => {
            this.maritalStatus = res.data.maritalStatuses
            this.genders = res.data.genders
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    prefillData(){
      if(this.getUser != null){
        this.obj.firstName = this.getUser.firstName
        this.obj.lastName = this.getUser.lastName
        this.obj.middleName = this.getUser.middleName
        this.obj.phone = this.getUser.phone
        this.obj.utmeReg = this.getUser.jambRegistrationNumber
        if(this.getInformation != null){
          let i = this.getInformation
          this.obj.placeOfBirth = i.placeOfBirth
          this.obj.dob = DateUtil.toDateOnly(i.dob)
          if(i.gender != null)
            this.obj.genderId = i.gender.id
          if(i.maritalStatus != null)
            this.obj.maritalStatusId = i.maritalStatus.id
          this.obj.homeTown = i.homeTown
          // country
          if(i.country != null) {
            this.obj.countryId = i.country.id
            this.selectedCountry = i.country.id
          }
          // state
          if(i.state != null)
            this.obj.stateId = i.state.id
          if(i.lga != null)
            this.obj.lgaId = i.lga.id
        }
      }
    }
  },

  watch: {
    menu: function(val){
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },

    selectedCountry: function(newVal){
      if(newVal != null){
        this.selectedState = null
        this.states = []
        this.loadStates()
      }
    },

    selectedState: function(newVal){
      if(newVal != null && !this.isEditing){
        this.loadLgas()
      }
    },

    getUser: function(val){
      if(val != null){
        if(this.getUser.firstName != null) {
          // this.success()
          this.prefillData()
        }
      }
    }
  },

  computed: {
    ...mapGetters(['getUser', 'getInformation', 'getApplicantFee']),
    canEdit: function(){
      // status still not upto application complete
      return this.getUser != null && ((StudentStatus[this.getUser.studentStatus].value <= StudentStatus.APPLICATION_PENDING.value) || this.getInformation == null || this.getInformation.state == null)
        && !this.getUser.admission.applicationType.autoLoadUtme
    }
  },


  created() {
    // if basic data already completed
    if(this.getUser != null){
      // if(this.getUser.firstName != null)
      //   this.success()
      this.prefillData()
    }

    this.loadCountries()
    this.loadBasicInfo()
    this.noHeader && this.$emit('update-title', "Basic Details")
  }
}
</script>

<style scoped>

</style>
